export const DISCUSSION_DRAWER_MODES = Object.freeze({
  CLASSIC: "classic",
  BRANCH: "branch",
});

export const DEFAULT_DISCUSSION_DRAWER_MODE = DISCUSSION_DRAWER_MODES.CLASSIC;

export const DISCUSSION_DRAWER_MODE_STORAGE_KEY = "sproutly:discussionDrawerMode";

export const DISCUSSION_DRAWER_MODE_EVENT = "sproutly:discussion-drawer-mode";

export function normalizeDiscussionDrawerMode(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return Object.values(DISCUSSION_DRAWER_MODES).includes(normalized)
    ? normalized
    : DEFAULT_DISCUSSION_DRAWER_MODE;
}

